<template>
    <div id="payment-posting-container">
        <div class="page-height">
            <b-row>
                <b-col>
                    <MdTitle v-bind:Text="title" />
                </b-col>
            </b-row>
        </div>

        <b-row>
            <b-col sm="12" md="12" lg="12">
                <insurance-patient-selection
                    v-model="parameters"
                    @patient-selected="patientSelectedHandler"
                    @patient-removed="patientRemovedHandler"
                    :ref="'patientSelectionCmp'"
                    :readOnly="editMode || isModified"
                    :deleteActionDisabled="patientDeleteActionDisabled"
                ></insurance-patient-selection>
            </b-col>
        </b-row>

        <b-row>
            <b-col sm="12" md="12" lg="12">
                <insurance-header-payment-posting-entry
                    v-model="filteredItems"
                    :ref="'headerEntryCmp'"
                    :data="headerParameters"
                    :editMode="editMode"
                    @change-data="headerParameters = $event"
                    :displayOption="parameters.displayOption"
                    :insuranceCompany="parameters.insuranceName"
                ></insurance-header-payment-posting-entry>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="gotoBackHandler"
            />
            <b-dropdown
                id="dropdown-dropup"
                dropup
                :text="$tc('Shared.ActionsTxt', 2)"
                variant="primary"
                class="m-2"
            >
                <b-dropdown-item-button v-on:click="saveOrEditHandler(true)">
                    {{ $t('Shared.Save') }}
                </b-dropdown-item-button>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button v-on:click="clearAllHandler" v-if="hasModifications">
                    {{ $t('Shared.ClearAll') }}
                </b-dropdown-item-button>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button v-on:click="autoApplyHandler">
                    {{ $t('PostPayment.Manual.AutoApply') }}
                </b-dropdown-item-button>
                <b-dropdown-item-button v-on:click="autoAdjustHandler">
                    {{ $t('PostPayment.Manual.AutoAdjust') }}
                </b-dropdown-item-button>
                <b-dropdown-item-button v-on:click="applyDeniedHandler">
                    {{ $t('PostPayment.Manual.ApplyDenied') }}
                </b-dropdown-item-button>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button v-on:click="processPayHandler">
                    {{ $t('PostPayment.Manual.ProcessPay') }}
                </b-dropdown-item-button>
            </b-dropdown>
        </div>
    </div>
</template>

<script>
import InsuranceHeaderPaymentPostingEntry from './insHeaderPaymentPostingEntry.vue';
import InsurancePatientSelection from './insPatientSelection.vue';
import PostPaymentService from '@/services/postPayment.service';
import GlobalService from '@/services/global.service';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '@/event-bus.js';
import Utils from '@/common/utils.js';

export default {
    name: 'InsurancePaymentPosting',
    mixins: [ShowMessage, DBFunctions],
    components: { InsuranceHeaderPaymentPostingEntry, InsurancePatientSelection },
    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                favButtonAtion: false
            },
            items: [],
            summaryItems: [],
            parameters: {
                insuranceCode: '',
                insuranceName: '',
                dateTo: null,
                dateFrom: null,
                displayOption: 1,
                isHideVoid: false,
                incTransaction: false
            },
            headerParameters: {
                paymentType: null,
                paymentDate: Utils.formatterNowToDate(),
                paymentReference: null,
                paymentAmount: null,
                sysDate: null,
                transNo: null
            },
            patientItems: [],
            pendingChanges: false,
            headerId: this.$route.params.id,
            editMode: this.$attrs.editMode ?? false,
            itemsBackup: {
                details: [],
                summaries: []
            }
        };
    },
    computed: {
        isPatientPaymentSource() {
            return (this.$attrs.source || '').toLowerCase() === 'patient';
        },
        title() {
            return this.editMode
                ? this.$t('PostPayment.Manual.TitleEdit')
                : this.$t('PostPayment.Manual.TitleAdd');
        },
        patientSelectionCmp() {
            return this.$refs.patientSelectionCmp;
        },
        headerEntryCmp() {
            return this.$refs.headerEntryCmp;
        },
        filteredItems() {
            if (this.parameters.displayOption === 0) {
                return this.summaryItems;
            }

            return this.items;
        },
        isModified() {
            const items = this.parameters.displayOption === 0 ? this.summaryItems : this.items;
            const disabled = items.some(element => element.isModified || element.id);

            return disabled;
        },
        hasModifications() {
            const items = this.parameters.displayOption === 0 ? this.summaryItems : this.items;
            const modified = items.some(element => element.isModified);

            return modified;
        }
    },
    methods: {
        gotoBackHandler() {
            this.$router.push({ name: 'manual-payment-posting' });
        },

        patientDeleteActionDisabled(item) {
            const items = this.parameters.displayOption === 0 ? this.summaryItems : this.items;
            const disabled = items.some(
                element =>
                    element.patientCode.trim() === item.patientCode.trim() &&
                    (element.isModified || element.id)
            );

            return disabled;
        },

        async searchClaimsAsync(patientItems, dateFrom, dateTo) {
            try {
                const parameters = {
                    dateFrom,
                    dateTo,
                    insuranceCode: this.parameters.insuranceCode,
                    displayOption: this.insuranceCode,
                    patientCodeList: patientItems.map(x => x.patientCode.trim()),
                    isHideVoid: this.parameters.isHideVoid,
                    incTransaction: this.parameters.incTransaction
                };

                const response = await PostPaymentService.getPaymentPostingClaims(parameters);
                const items = response.data.details;
                items.forEach(element => {
                    element.amtAllowed = 0;
                    element.amtDeduct = 0;
                    element.amtCoins = 0;
                    element.payBenefit = 0;
                    element.amtNonAllowed = 0;
                    element.adjAmt = 0;
                    element.icnNumber = '';
                    element.payProvider = 0;
                    element.isModified = false;
                    element.payCodeDescription = '';
                    element.rowKey = element.seqNo;
                    element.outlier = 0;
                    element.multiAdjAmt = null;

                    this.items.push(element);
                });

                const summaryItems = response.data.summary;
                summaryItems.forEach(element => {
                    element.amtAllowed = 0;
                    element.amtDeduct = 0;
                    element.amtCoins = 0;
                    element.payBenefit = 0;
                    element.amtNonAllowed = 0;
                    element.adjAmt = 0;
                    element.icnNumber = '';
                    element.payProvider = 0;
                    element.isModified = false;
                    element.payCodeDescription = '';
                    element.rowKey = Utils.generateRecID();
                    element.outlier = 0;
                    element.multiAdjAmt = null;

                    this.summaryItems.push(element);
                });
            } catch (error) {
                this.showResponseErrorMessage(error);
            }
        },

        patientSelectedHandler({ patientSelected, patientAppends, dateFrom, dateTo }) {
            this.patientItems = patientSelected;

            if (this.patientItems.length === 0) {
                this.items = [];
                this.summaryItems = [];
            }

            if (patientAppends.length !== 0) {
                this.searchClaimsAsync(patientAppends, dateFrom, dateTo);
            }
        },

        patientRemovedHandler(patientCode) {
            let indexOf = this.patientItems.findIndex(
                patient => patient.patientCode === patientCode
            );

            if (indexOf !== -1) {
                this.patientItems.splice(indexOf, 1);
            }

            this.items = this.items.filter(x => x.patientCode !== patientCode);
            this.summaryItems = this.summaryItems.filter(x => x.patientCode !== patientCode);
        },

        async processPayHandler() {
            if (this.pendingChanges) {
                if (this.validate_required() && this.validate_payment()) {
                    try {
                        const response = await PostPaymentService.isDuplicatePay({
                            paymentReference: this.headerParameters.paymentReference,
                            insuranceCode: this.parameters.insuranceCode
                        });

                        if (response.data.isDuplicatePay) {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                this.$t('PostPayment.Manual.DuplicatedPaymentMsg', {
                                    TransNumber: response.data.transactionNumber
                                }),
                                'errorAutoHide'
                            );

                            return;
                        }

                        if (this.editMode) {
                            await this.editAndProcessPayAsync();
                        } else {
                            await this.addAndProcessPayAsync();
                        }
                    } catch (error) {
                        this.showResponseErrorMessage(error);
                    }
                }
            } else if (this.validate_payment()) {
                try {
                    const response = await PostPaymentService.isDuplicatePay({
                        paymentReference: this.headerParameters.paymentReference,
                        insuranceCode: this.parameters.insuranceCode
                    });

                    if (response.data.isDuplicatePay) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('PostPayment.Manual.DuplicatedPaymentMsg', {
                                TransNumber: response.data.transactionNumber
                            }),
                            'errorAutoHide'
                        );

                        return;
                    }

                    await this.processPayAsync();
                } catch (error) {
                    this.showResponseErrorMessage(error);
                }
            }
        },

        async saveOrEditHandler(gotoBack) {
            let retVal = true;
            if (this.pendingChanges) {
                if (this.validate_required()) {
                    try {
                        if (this.editMode) {
                            retVal = await this.editHandleAsync();
                        } else {
                            retVal = await this.addHandleAsync();
                        }

                        if (gotoBack && retVal) {
                            this.gotoBackHandler();
                        }
                    } catch (error) {
                        this.showResponseErrorMessage(error);
                    }
                }
            } else if (gotoBack) {
                this.gotoBackHandler();
            }

            return retVal;
        },

        async editHandleAsync() {
            let retVal = true;
            const data = this.prepare();
            data['transNo'] = this.headerParameters.transNo;

            try {
                await PostPaymentService.updatePaymentPostingDraft(this.headerId, data);
                this.pendingChanges = false;

                setTimeout(
                    () =>
                        this.showMessage(
                            this.$t('Msg.Success'),
                            this.$t('Shared.SavedSuccessfully'),
                            'success'
                        ),
                    50
                );
            } catch (error) {
                this.showResponseErrorMessage(error);
                retVal = false;
            }

            return retVal;
        },

        async addHandleAsync() {
            let retVal = true;
            const data = this.prepare();
            data['sysDate'] = this.headerParameters.sysDate;

            try {
                await PostPaymentService.addPaymentPostingDraft(data);

                this.pendingChanges = false;

                setTimeout(
                    () =>
                        this.showMessage(
                            this.$t('Msg.Success'),
                            this.$t('Shared.SavedSuccessfully'),
                            'success'
                        ),
                    50
                );
            } catch (error) {
                this.showResponseErrorMessage(error);
                retVal = false;
            }

            return retVal;
        },

        async processPayAsync() {
            try {
                console.log('processPayAsync', { headerId: this.headerId });
                const response = await PostPaymentService.processInsurancePay({
                    headerId: this.headerId
                });

                setTimeout(
                    () =>
                        this.showMessage(
                            this.$t('Msg.Success'),
                            this.$t('PostPayment.Manual.PaymentSuccessfullyMsg', {
                                TransNumber: response.data.transactionNumber
                            }),
                            'success'
                        ),
                    50
                );

                this.gotoBackHandler();
            } catch (error) {
                this.showResponseErrorMessage(error);
            }
        },

        async editAndProcessPayAsync() {
            const data = this.prepare();
            data['transNo'] = this.headerParameters.transNo;

            try {
                console.log('editAndProcessPayAsync', {
                    headerId: this.headerId,
                    dataToUpdate: data
                });
                const response = await PostPaymentService.processInsurancePay({
                    headerId: this.headerId,
                    dataToUpdate: data
                });
                this.pendingChanges = false;

                setTimeout(
                    () =>
                        this.showMessage(
                            this.$t('Msg.Success'),
                            this.$t('PostPayment.Manual.PaymentSuccessfullyMsg', {
                                TransNumber: response.data.transactionNumber
                            }),
                            'success'
                        ),
                    50
                );

                this.gotoBackHandler();
            } catch (error) {
                this.showResponseErrorMessage(error);
            }
        },

        async addAndProcessPayAsync() {
            const data = this.prepare();
            data['sysDate'] = this.headerParameters.sysDate;

            try {
                console.log('addAndProcessPayAsync', {
                    headerId: this.headerId,
                    dataToInsert: data
                });
                const response = await PostPaymentService.processInsurancePay({
                    headerId: this.headerId,
                    dataToInsert: data
                });
                this.pendingChanges = false;

                setTimeout(
                    () =>
                        this.showMessage(
                            this.$t('Msg.Success'),
                            this.$t('PostPayment.Manual.PaymentSuccessfullyMsg', {
                                TransNumber: response.data.transactionNumber
                            }),
                            'success'
                        ),
                    50
                );

                this.gotoBackHandler();
            } catch (error) {
                this.showResponseErrorMessage(error);
            }
        },

        prepare() {
            const items = this.parameters.displayOption === 0 ? this.summaryItems : this.items;
            const details = items
                .filter(x => x.isModified)
                .map(element => ({
                    adjAmt: element.adjAmt || 0,
                    amtAllowed: element.amtAllowed,
                    amtCoins: element.amtCoins,
                    amtDeduct: element.amtDeduct,
                    amtNonAllowed: element.amtNonAllowed,
                    insuranceCode: this.parameters.insuranceCode.trim(),
                    issLineNo: element.issLineNo,
                    patientCode: element.patientCode.trim(),
                    payBenefit: element.payBenefit,
                    payCode: element.payCode,
                    payProvider: element.payProvider,
                    outlier: element.outlier,
                    icnNumber: element.icnNumber,
                    reasonNo: element.reasonNo,
                    id: element.id,
                    charges: element.charges,
                    multiAdjAmt: element.multiAdjAmt,
                    dateFrom: element.dateFrom,
                    dateTo: element.dateTo
                }));

            return {
                insuranceCode: this.parameters.insuranceCode.trim(),
                patientCodeList: this.patientItems.map(x => x.patientCode.trim()).join(','),
                payDate: this.headerParameters.paymentDate,
                amount: this.headerParameters.paymentAmount,
                payRef: this.headerParameters.paymentReference,
                payType: this.getPaymentTypeString(this.headerParameters.paymentType),
                dateFrom: this.parameters.dateFrom,
                dateTo: this.parameters.dateTo,
                displayOption: this.parameters.displayOption,
                details: details
            };
        },

        validate_required() {
            const patientSelectionValid = this.patientSelectionCmp.validate_required();
            const headerEntryCmpValid = this.headerEntryCmp.validate_required();
            const valid = patientSelectionValid && headerEntryCmpValid;

            if (!valid) {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.CheckRedLabeledFields'),
                    'errorAutoHide'
                );

                return false;
            }

            const items = this.parameters.displayOption === 0 ? this.summaryItems : this.items;
            if (!this.editMode && !items.some(element => element.isModified)) {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('PostPayment.Manual.InvalidPaymentApplied'),
                    'errorAutoHide'
                );
                return false;
            }

            return true;
        },

        validate_payment() {
            const items = this.parameters.displayOption === 0 ? this.summaryItems : this.items;
            const apply = items.reduce((sum, p) => sum + (p.payProvider || 0), 0);
            const toApply = parseFloat((this.headerParameters.paymentAmount - apply).toFixed(2));

            if (toApply !== 0) {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('PostPayment.Manual.AmountZeroInvalid'),
                    'errorAutoHide'
                );

                return false;
            }

            return true;
        },

        getPaymentTypeString(paymentType) {
            return ['CHECK', 'CR CARD', 'CASH', 'OTHER', 'EFT'][paymentType - 1];
        },

        getDateTime() {
            if (!this.editMode) {
                GlobalService.getDateTime()
                    .then(response => {
                        if (response.data) {
                            this.headerParameters.sysDate = response.data;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        async getPaymentPostingAsync() {
            try {
                if (this.editMode) {
                    const response = await PostPaymentService.getPaymentPostingDraft(this.headerId);
                    const data = response.data;
                    const details = [...data.details];
                    details.forEach(element => {
                        element.isModified = false;
                        element.rowKey = element.seqNo;

                        const totalAdjAmt = element.multiAdjAmt
                            ? element.multiAdjAmt
                                  .reduce((sum, p) => sum + (p.adjAmt || 0.0), 0.0)
                                  .toFixed(2)
                            : 0;

                        element.newBalance = parseFloat(
                            (
                                element.balance -
                                element.payProvider -
                                (element.adjAmt + totalAdjAmt)
                            ).toFixed(2)
                        );

                        if (
                            element.multiAdjAmt &&
                            Array.isArray(element.multiAdjAmt) &&
                            element.multiAdjAmt.length > 0
                        ) {
                            element.adjAmt = null;
                        }
                    });

                    const summary = [...data.summary];
                    summary.forEach(element => {
                        element.isModified = false;
                        element.rowKey = element.id;

                        const totalAdjAmt = element.multiAdjAmt
                            ? element.multiAdjAmt
                                  .reduce((sum, p) => sum + (p.adjAmt || 0.0), 0.0)
                                  .toFixed(2)
                            : 0;

                        element.newBalance = parseFloat(
                            (
                                element.balance -
                                element.payProvider -
                                (element.adjAmt + totalAdjAmt)
                            ).toFixed(2)
                        );

                        if (
                            element.multiAdjAmt &&
                            Array.isArray(element.multiAdjAmt) &&
                            element.multiAdjAmt.length > 0
                        ) {
                            element.adjAmt = null;
                        }
                    });

                    this.items = details;
                    this.summaryItems = summary;

                    this.itemsBackup.details = JSON.parse(JSON.stringify(details));
                    this.itemsBackup.summaries = JSON.parse(JSON.stringify(summary));

                    const patientItems = data.patientsList.map(x => ({
                        patientCode: x.code,
                        patientName: x.description
                    }));
                    this.patientItems = patientItems;
                    this.patientSelectionCmp.resetPatientList(patientItems);
                    this.patientSelectionCmp.resetDisplayOption(data.displayOption);
                    this.patientSelectionCmp.insuranceCodeVModel = {
                        code: data.insuranceCode,
                        description: data.insuranceName
                    };

                    this.parameters = {
                        insuranceCode: data.insuranceCode,
                        insuranceName: data.insuranceName,
                        dateTo: data.dateTo,
                        dateFrom: data.dateFrom,
                        displayOption: data.displayOption
                    };

                    const indexOf = ['', 'CHECK', 'CR CARD', 'CASH', 'OTHER', 'EFT'].indexOf(
                        data.payType?.toUpperCase()
                    );
                    this.headerParameters = {
                        paymentType: indexOf,
                        paymentDate: data.payDate,
                        paymentReference: data.payRef,
                        paymentAmount: data.amount,
                        sysDate: data.sysData,
                        transNo: data.transNo
                    };

                    this.headerEntryCmp.resetPaymentType(data.payType);
                }
            } catch (error) {
                this.showResponseErrorMessage(error);
            }
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        },

        async initializeAsync() {
            try {
                await Promise.allSettled([this.getDateTime(), this.getPaymentPostingAsync()]);
            } finally {
                EventBus.$on(
                    'onChanged',
                    function(e) {
                        const componentName = [
                            this.$t('Shared.PaymentMethod'),
                            'payment-reference',
                            'payment-amount',
                            'payment-date',
                            'payment-posting-cell'
                        ];

                        if (componentName.some(x => x === e.ComponentName)) {
                            this.pendingChanges = e.Changed;
                        }
                    }.bind(this)
                );
            }
        },

        clearAllHandler() {
            this.$bvModal
                .msgBoxConfirm(this.$t('modalMarsMed.ChangingWithoutSaving'), {
                    title: this.$t('PostPayment.Manual.Title'),
                    okTitle: this.$t('Shared.ClearAll'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        this.clearAllItems();
                    }
                });
        },

        clearAllItems() {
            this.items.forEach(element => {
                if (element.isModified) {
                    const indexOf = this.itemsBackup.details.findIndex(x => x.id === element.id);

                    if (indexOf !== -1) {
                        const details = this.itemsBackup.details[indexOf];
                        element.isModified = false;

                        element.amtAllowed = details.amtAllowed;
                        element.amtDeduct = details.amtDeduct;
                        element.amtCoins = details.amtCoins;
                        element.payBenefit = details.payBenefit;
                        element.amtNonAllowed = details.amtNonAllowed;
                        element.adjAmt = details.adjAmt;
                        element.icnNumber = details.icnNumber;
                        element.payProvider = details.payProvider;
                        element.payCodeDescription = details.payCodeDescription;
                        element.outlier = details.outlier;
                        element.multiAdjAmt = details.multiAdjAmt;
                    } else {
                        element.newBalance = element.balance;
                        element.isModified = false;

                        element.amtAllowed = 0;
                        element.amtDeduct = 0;
                        element.amtCoins = 0;
                        element.payBenefit = 0;
                        element.amtNonAllowed = 0;
                        element.adjAmt = 0;
                        element.icnNumber = '';
                        element.payProvider = 0;
                        element.payCodeDescription = '';
                        element.outlier = 0;
                        element.multiAdjAmt = null;
                    }
                }
            });

            this.summaryItems.forEach(element => {
                if (element.isModified) {
                    const indexOf = this.itemsBackup.details.findIndex(x => x.id === element.id);

                    if (indexOf !== -1) {
                        const details = this.itemsBackup.details[indexOf];
                        element.isModified = false;

                        element.amtAllowed = details.amtAllowed;
                        element.amtDeduct = details.amtDeduct;
                        element.amtCoins = details.amtCoins;
                        element.payBenefit = details.payBenefit;
                        element.amtNonAllowed = details.amtNonAllowed;
                        element.adjAmt = details.adjAmt;
                        element.icnNumber = details.icnNumber;
                        element.payProvider = details.payProvider;
                        element.payCodeDescription = details.payCodeDescription;
                        element.outlier = details.outlier;
                        element.multiAdjAmt = details.multiAdjAmt;
                    } else {
                        element.newBalance = element.balance;
                        element.isModified = false;

                        element.amtAllowed = 0;
                        element.amtDeduct = 0;
                        element.amtCoins = 0;
                        element.payBenefit = 0;
                        element.amtNonAllowed = 0;
                        element.adjAmt = 0;
                        element.icnNumber = '';
                        element.payProvider = 0;
                        element.payCodeDescription = '';
                        element.outlier = 0;
                        element.multiAdjAmt = null;
                    }
                }
            });
        },

        autoApplyHandler() {
            this.headerEntryCmp.autoApplyHandler();
        },

        autoAdjustHandler() {
            this.headerEntryCmp.autoAdjustHandler();
        },

        applyDeniedHandler() {
            this.headerEntryCmp.applyDeniedHandler();
        }
    },

    created() {
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    async mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;

        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        await this.initializeAsync();
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
        EventBus.$off('onChanged');
    },

    beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.title,
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if (!value) {
                        next();
                    } else {
                        const saved = await this.saveOrEditHandler(false);
                        if (saved) {
                            next();
                        }
                    }
                });
        } else {
            next();
        }
    }
};
</script>
